import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ConfirmationDialogResolve = (
  confirmed: boolean,
  reason?: string
) => void;

export interface ConfirmationDialogState {
  isOpen: boolean;
  message: string;
  title?: string;
  requireReason?: boolean;
  reasonLabel?: string;
  resolve: ConfirmationDialogResolve | null;
}

const initialState: ConfirmationDialogState = {
  isOpen: false,
  message: "",
  title: undefined,
  requireReason: false,
  reasonLabel: undefined,
  resolve: null,
};

const confirmationDialogSlice = createSlice({
  name: "confirmationDialog",
  initialState,
  reducers: {
    showConfirmationDialog: (
      state,
      action: PayloadAction<{
        message: string;
        title?: string;
        requireReason?: boolean;
        reasonLabel?: string;
        resolve: ConfirmationDialogResolve;
      }>
    ) => {
      state.isOpen = true;
      state.message = action.payload.message;
      state.title = action.payload.title;
      state.requireReason = Boolean(action.payload.requireReason);
      state.reasonLabel = action.payload.reasonLabel;
      state.resolve = action.payload.resolve;
    },
    confirmDialog: (state, action: PayloadAction<{ reason?: string } | undefined>) => {
      const resolve = state.resolve;
      const reason = String(action.payload?.reason ?? "").trim();
      state.isOpen = false;
      state.message = "";
      state.title = undefined;
      state.requireReason = false;
      state.reasonLabel = undefined;
      state.resolve = null;
      if (resolve) {
        setTimeout(() => resolve(true, reason), 0);
      }
    },
    cancelDialog: (state) => {
      const resolve = state.resolve;
      state.isOpen = false;
      state.message = "";
      state.title = undefined;
      state.requireReason = false;
      state.reasonLabel = undefined;
      state.resolve = null;
      if (resolve) {
        setTimeout(() => resolve(false, ""), 0);
      }
    },
  },
});

export const {
  showConfirmationDialog,
  confirmDialog,
  cancelDialog,
} = confirmationDialogSlice.actions;

export default confirmationDialogSlice.reducer;
